export const getFieldCaption = (formConfig, fieldName) => formConfig?.fields?.find((field) => field.dataField === fieldName)?.caption || fieldName;

export const blocksTransactionSubmit = (validationResult) => !!validationResult?.blockTransactionSubmit;

export function resolveValidationScope(requestedFieldName, validationResult) {
    const validatedFields = validationResult?.validatedFields?.length
        ? validationResult.validatedFields
        : requestedFieldName
          ? [requestedFieldName]
          : [];
    const autofilledFields = validationResult?.autofilledFields || [];
    return { validatedFields, autofilledFields };
}

export function applyValidationScope(prevMap, { validatedFields, autofilledFields, createEntry }) {
    const newMap = { ...prevMap };

    const coveredFields = [...(validatedFields || []), ...(autofilledFields || []).map(({ field }) => field)];
    coveredFields.forEach((fieldName) => {
        delete newMap[fieldName];
    });

    if (typeof createEntry !== 'function') return newMap;

    (validatedFields || []).forEach((fieldName) => {
        const entry = createEntry(fieldName);
        if (entry) newMap[fieldName] = entry;
    });

    return newMap;
}

export function buildBlockingEntry({ fieldName, validationResult, label }) {
    if (!blocksTransactionSubmit(validationResult)) return null;
    return {
        dataField: fieldName,
        ruleId: validationResult.ruleId ?? null,
        status: validationResult.status ?? null,
        message: validationResult.message ?? null,
        label: label || fieldName,
    };
}

export const hasBlockingValidations = (blockingValidations) => Object.keys(blockingValidations || {}).length > 0;

export const toFailedValidations = (blockingValidations) =>
    Object.values(blockingValidations || {}).map(({ dataField, ruleId, status, message }) => ({ dataField, ruleId, status, message }));

export function overrideCoversBlockingValidations(lookupOverride, blockingValidations) {
    const covered = new Set((lookupOverride?.resultSnapshot?.failedValidations || []).map(({ dataField }) => dataField));
    return Object.keys(blockingValidations || {}).every((dataField) => covered.has(dataField));
}
